import { returnPath } from "~/features/common/utils/navigation/returnPath";

export const getIndexPath = returnPath("/admin/points-system");
export const getIdPath = returnPath("/admin/points-system/:id");
